import { Component, Input } from '@angular/core';

@Component({
  selector: 'inova-truncated-text',
  templateUrl: './truncated-text.component.html',
  styleUrls: ['./truncated-text.component.css']
})
export class TruncatedTextComponent {

  @Input() text:string="";
  @Input() displayFull:boolean=false;
  @Input() maxLength:number=20;
  @Input() containerClass:string="";
  @Input() tooltipClass:string="tooltip-help";

  constructor() {}

  getTextValue(){
    if(!this.displayFull){
      if(this.isTextOverLimit()){
        return this.text.substring(0,this.maxLength)+"..."
      }
      else{
        return this.text;
      }
      
    }
    else{
      return this.text;
    }
  }

  isTextOverLimit(){
    return this.text.length>this.maxLength;
  }

  getTooltip(){
    if(this.isTextOverLimit() && !this.displayFull){
      return this.text;
    }
    return "";
  }

  getContainerClass(){
    return "title-lbl "+this.containerClass;
  }

}
